export const workforceAccessModes = {
  applicant: {
    key: 'applicant',
    accessType: 'application',
    eyebrow: 'Applicant',
    label: 'Continue your application',
    title: 'Continue onboarding',
    description: 'Application, onboarding, references and forms.',
    shortDescription: 'Onboarding, CV, references and forms.',
    button: 'Email my application link',
    publicTitle: 'Continue my application',
    publicDescription: 'Return to onboarding, documents, references and messages using your registered email.',
  },
  worker: {
    key: 'worker',
    accessType: 'workforce',
    eyebrow: 'Worker',
    label: 'Open your work portal',
    title: 'Open my work app',
    description: 'Shifts, training, compliance and work tasks.',
    shortDescription: 'Shifts, training and compliance tasks.',
    button: 'Email my work app link',
    publicTitle: 'Access worker portal',
    publicDescription: 'Open shifts, training, policies and compliance tasks with the same secure email link.',
  },
};

export const workforceAccessModeOrder = ['applicant', 'worker'];

export function getWorkforceAccessMode(mode) {
  return workforceAccessModes[mode] || workforceAccessModes.applicant;
}

export function accessTypeToMode(accessType) {
  return Object.values(workforceAccessModes).find((mode) => mode.accessType === accessType)?.key || 'applicant';
}

export function accessPrivacyCopy({ tenantName = '', publicPage = false } = {}) {
  if (publicPage) {
    return 'For privacy, we show the same response for every email. If your email is recognised in one workplace, we send the correct private link.';
  }
  const provider = tenantName || 'this workplace';
  return `For privacy, we show the same response for every email. Only recognised applicants and workers for ${provider} receive a link.`;
}

